import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppComponent } from './app.component';
import { AlgebraKITModule } from './modules/algebrakit/algebrakit.module';
import { PlayerContainer } from './containers/player/player.container';
import { ExerciseResultComponent } from './components/exercise-result/exercise-result.component';
import { SkillTagViewerComponent } from './components/exercise-result/skill-tag-viewer/skill-tag-viewer.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { ExerciseDataComponent } from './components/exercise-data/exercise-data.component';
import { EditorContainer } from './containers/editor/editor.container';
import { AkitHeaderComponent } from './components/akit-header/akit-header.component';
import { FormulaEditorContainer } from './containers/formula-editor/formula-editor.container';
import { SafeHtmlPipe } from './pipes/safeHtml.pipe';
import { AkitMathAreaComponent } from './modules/algebrakit/components/akit-matharea/akit-matharea.component';
import { DemoContainer } from './containers/demo/demo.container';


@NgModule({
  declarations: [
    AppComponent, PlayerContainer, DemoContainer, EditorContainer, ExerciseResultComponent, ExerciseDataComponent, SkillTagViewerComponent,
    AkitHeaderComponent, FormulaEditorContainer,SafeHtmlPipe, AkitMathAreaComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AlgebraKITModule,
    FormsModule,
    ReactiveFormsModule,
    NgxJsonViewerModule
    
  ],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
